import { createFileRoute, Outlet } from '@tanstack/react-router'

import type { TabItem } from '@/components/shell'
import { PhoneShell } from '@/components/shell'

const KLIENT_TABS: TabItem[] = [
  { label: 'Přehled', href: '/klient/prehled', icon: 'grid' },
  { label: 'Plán', href: '/klient/plan', icon: 'calendar' },
  { label: 'Chat', href: '/klient/chat', icon: 'comment' },
  { label: 'Focení', href: '/klient/foceni', icon: 'camera' },
  { label: 'Knihovna', href: '/klient/knihovna', icon: 'folder' },
]

export const Route = createFileRoute('/klient')({
  component: KlientLayout,
})

function KlientLayout() {
  return (
    <PhoneShell tabs={KLIENT_TABS}>
      <Outlet />
    </PhoneShell>
  )
}
